import { makeStyles } from '@material-ui/core/styles';
import signinIcon from '../../assets/SignIn/SignIn.svg';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: '#ddd',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: `url(${signinIcon})`,
    backgroundPosition: "bottom left",
    backgroundRepeat: "no-repeat",
    backgroundSize: 'contain',
  },

  wrapper: {
    maxWidth: '58.8em',
    padding: '3.9em 4.9em',
    marginTop: '4.5em',
    marginBottom: '3.3em',
    backgroundColor: '#fff',
    borderRadius: 12,
    boxShadow: "0 1px 14px 7px rgba(0,0,0,0.05), 0 1px 3px 0 rgba(0,0,0,0.2)",
    [theme.breakpoints.down('md')]: {
      width: '100%',
      padding: '20px',
      margin: '50px 15px'
    },
  },

  title: {
    color: "#535D6D",
    fontFamily: "Montserrat",
    fontSize: '3.6em',
    lineHeight: 1,
    marginTop: 10,
    fontWeight: "600",
    letterSpacing: "0.95px",
    marginBottom: 40,
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      fontSize: '2.6em',
    },
  },

  hintText: {
    color: "rgba(0,0,0,0.74)",
    fontFamily: "Montserrat",
    fontSize: '1.6em',
    fontWeight: '500',
    letterSpacing: '0.5px',
    marginTop: 0
  },

  inputContainer: {
    marginBottom: 20,
  },

  inputStyle: {
    color: "rgba(0,0,0,0.87)",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "600"
  },

  btnContainer: {
    width: '100%',    
  },

  sendBtn: {
    fontFamily: "Montserrat",
    fontSize: '1.6em',
    display: 'block',
    fontWeight: '600',
    height: '50px',
    marginBottom: '20px'
  },

  orContainer: {
    width: '80%',
    margin: '0 auto',
    borderTop: 'solid 1px #979797',
    position: 'relative',
    marginBottom: 20,
  },

  orWraper: {
    width: 30,
    height: 30,
    position: 'absolute',
    top: -16,
    left: '45%',
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },

  orText: {
    color: "#727272",
    fontFamily: "Montserrat",
    fontSize: "1.4em",
    fontWeight: "500",
    margin: 0,
  },

  errorMsg: {
    fontSize: '1.4em',
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 10,
    fontFamily: 'Montserrat',
    color: "red",
  },

  submitBtn: {
    fontFamily: "Montserrat",
    fontSize: '1.6em',
    fontWeight: '600',
    marginBottom: 20,
    height: 50,
  },

  backBtn: {
    textAlign: 'center',
    color: '#535D6D !important',
    borderColor: theme.palette.primary.main,
    border: '2px solid',
    boxShadow: "0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2)",
    height: '50px',
    fontSize: '1.6em',
    boxShadow: '0px 4px 8px 0 rgba(0,0,0,0.14)',
    fontFamily: 'Montserrat',
    fontWeight: '600',
  },

  otherLinkStyle: {
    color: "#235A86",
    fontFamily: "Montserrat",
    fontSize: '1em',
    fontWeight: "600",
    letterSpacing: "0.47px",
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    },
  },

}));

